import { Box, Button, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';

export const DEFAULT_REGISTRATION_FIELDS = {
  fields: [
    {
      name: 'faktura_nr',
      required: true,
      type: 'string',
      component: 'text-field',
      label: 'Fakturanummer',
      description: 'Fakturanummer',
    },
    {
      component: 'display-text',
      label: 'Some instructional text',
    },
    {
      name: 'tickets',
      type: 'string',
      component: 'select',
      label: 'Ticket',
      description: 'Select ticket',
      default: 'regular',
      options: [
        { value: 'regular', label: 'Regular' },
        { value: 'vip', label: 'VIP' },
      ],
    },
    {
      name: 'email_marketing',
      required: false,
      type: 'boolean',
      component: 'checkbox',
      label:
        'Do you want to receive marketing emails? Read more at https://mailchimp.com',
    },
  ],
};

export const DEFAULT_REGISTRATION_JSON = JSON.stringify(
  DEFAULT_REGISTRATION_FIELDS,
  null,
  3
);

/**
 * Build the full conference `update` payload with `registration_fields` overridden.
 *
 * The conference `update` endpoint rebuilds the whole record from req.body, so a
 * partial payload would blank out other columns (name, title, ...) and crash on
 * the required `name` check. We therefore send the existing conference fields it
 * reads, overriding only `registration_fields`.
 */
export const buildConferencePayload = (
  conference: any,
  registrationFields: string
) => ({
  name: conference.name,
  url_cname: conference.url_cname,
  title: conference.title,
  sub_title: conference.sub_title,
  description_summary: conference.description_summary,
  registration_type: conference.registration_type,
  privacy_agreement: conference.privacy_agreement,
  theme_live: conference.theme_live,
  theme_site: conference.theme_site,
  lang_data: conference.lang_data,
  settings_data: conference.settings_data,
  image: conference.image,
  chat_level: conference.chat_level,
  pretix_id: conference.pretix_id,
  allow_auto_login: conference.allow_auto_login,
  image_logo: conference.image_logo,
  state: conference.state,
  lang_iso: conference.lang_iso,
  organizationId: conference.organizationId,
  is_template: conference.is_template,
  template_description: conference.template_description,
  registration_fields: registrationFields,
});

interface ICustomFieldsEditorProps {
  initialJson: string;
  onJsonChange: (value: string) => void;
}

export const CustomRegistrationFieldsEditor = ({
  initialJson,
  onJsonChange,
}: ICustomFieldsEditorProps) => {
  const [json, setJson] = useState(initialJson);

  const handleChange = (value: string) => {
    setJson(value);
    onJsonChange(value);
  };

  return (
    <Box mt={1}>
      <Typography variant="h6">
        Custom registration fields (dont change after registration has started)
      </Typography>
      <TextField
        variant="outlined"
        fullWidth
        id="registration_fields"
        name="registration_fields"
        label="Custom registration JSON"
        multiline
        minRows={4}
        maxRows={10}
        value={json}
        onChange={(e) => handleChange(e.target.value)}
        margin="normal"
      />
      <Button
        size="small"
        onClick={() => handleChange(DEFAULT_REGISTRATION_JSON)}
      >
        Fill default
      </Button>
    </Box>
  );
};
